import { format, isToday, isYesterday } from 'date-fns';

function formatClock(date: Date): string {
  return format(date, 'h:mma').replace('AM', 'a').replace('PM', 'p');
}

/** Relative timestamp matching the sent-notifications mockup: "Today, 7:05a". */
export function formatMessageBoardTime(iso: string | Date): string {
  const date = typeof iso === 'string' ? new Date(iso) : iso;
  if (Number.isNaN(date.getTime())) return '';
  const clock = formatClock(date);
  if (isToday(date)) return `Today, ${clock}`;
  if (isYesterday(date)) return `Yesterday, ${clock}`;
  return `${format(date, 'EEE')}, ${clock}`;
}

export function messageBoardTitle(message: string): string {
  const first = message.split('\n')[0]?.trim() ?? '';
  return first || message;
}
